<template>
  <v-card-text class="pa-4">
    <p class="title black--text">Añadir una tarjeta de crédito o débito</p>
    <v-stripe-card
      hide-details
      ref="stripeCard"
      outlined
      solo
      hint="Por favor ingrese los detalles de la tarjeta"
      v-model="newCard"
      :api-key="stripeKey"
      :hidePostalCode="true"
      clearable
      @focus="onFocus"
      @input="onProcessed"
      :disabled="loadingFinalizar"
    ></v-stripe-card>
    <v-checkbox
      :disabled="disabledCheck"
      v-model="guardarTarjeta"
      label="Guardar la tarjeta para próximas compras"
      required
    ></v-checkbox>

    <div v-if="loadingFormasPago">
      <p>
        <v-skeleton-loader type="heading"></v-skeleton-loader>
      </p>
      <v-list-item-group>
        <v-card>
          <v-sheet v-for="(item,i) in 2" class="w-100" :key="i">
            <v-skeleton-loader type="list-item-avatar-two-line"></v-skeleton-loader>
          </v-sheet>
        </v-card>
      </v-list-item-group>

      <v-overlay opacity="0">
        <v-container class="d-flex align-center justify-center flex-column">
          <v-progress-circular size="50" width="8" indeterminate color="grey darken-4"></v-progress-circular>
        </v-container>
      </v-overlay>
    </div>
    <div v-else>
      <p class="title black--text">Tus tarjetas</p>
      <v-list-item-group v-model="settings" :disabled="loadingFinalizar">
        <v-card
          v-ripple="{ class: `success--text` }"
          v-for="(card, i) in formasFiltradas"
          :key="i"
          :value="card"
          :elevation="1"
          tile
          outlined
          min-width="100%"
          class="mb-4"
        >
          <v-list-item class="py-2">
            <template v-slot:default="{ active, toggle }">
              <v-list-item-action class>
                <v-checkbox v-model="active" color="success" @click="toggle"></v-checkbox>
              </v-list-item-action>

              <v-list-item-content class="ml-n4">
                <v-list-item-title class="subtitle-1">
                  Que termina en...
                  <span class="font-weight-bold">{{ $t(card.card.last4) }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  Expira en:
                  <span
                    class="font-weight-bold"
                  >{{card.card.exp_month}} / {{card.card.exp_year}}</span>
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text
                  small
                  class="subtitle-1 font-weight-light grey--text mt-n3 text-capitalize"
                >{{card.card.brand}}</v-list-item-action-text>
                <v-menu transition="scale-transition" bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" small class="mb-n3 mr-n2">
                      <v-icon size="20" class="black--text">mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>

                  <v-list width="256">
                    <!--<v-list-item @click="eliminar( card )">
                      <v-list-item-title>Eliminar tarjeta</v-list-item-title>
                    </v-list-item>-->
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-card>
      </v-list-item-group>
    </div>

    <div class="d-flex justify-center">
      <v-img
        class="white--text align-end"
        src="../../assets/img/logoPago.png"
        lazy-src="../../assets/img/logoPago.png"
        height="40"
        aspect-ratio="1.7"
        contain
      ></v-img>
    </div>
  </v-card-text>
</template>

 
<script>
import { mapState, mapActions } from "vuex";
import { configJson } from "@/utils/config";

export default {
  props: ["stripe", "options"],
  components: {},
  data() {
    return {
      disabledCheck: true,
      stripeCardInitialized: false,
      stripeOptions: {
        hidePostalCode: true
        // see https://stripe.com/docs/stripe.js#element-options for details
      },
      stripeKey: configJson.stripe.api_key,
      ex7: "red",
      mostrarAddButton: false,
      complete: false,
      settings: null
    };
  },

  computed: {
    dialogPagoStripe: {
      get() {
        return this.$store.state.pedido.stripeRequireAction;
      },
      set(v) {
        this.$store.commit("pedido/setStripeRequireAction", v);
      }
    },
    ...mapState({
      stripeDialog: state => state.pedido.stripeDialog,
      confirmarPagoDialog: state => state.pedido.confirmarPagoDialog,
      isLogged: state => state.auth.isLogged,
      formasPago: state => state.auth.formasPago,
      urlStripe: state => state.pedido.stripeRequireActionUrl,
      loadingFormasPago: state => state.auth.loadingFormasPago
    }),
    newCard: {
      get() {
        return this.$store.state.pedido.newCard;
      },
      set(val) {
        if (!val) {
          this.disabledCheck = true;
        } else {
          this.disabledCheck = false;
        }
        this.$store.commit("pedido/setNewCard", val);
      }
    },
    choosenCard: {
      get() {
        return this.$store.state.pedido.choosenCard;
      },
      set(val) {
        this.$refs.stripeCard.clearableCallback();
        this.$store.commit("pedido/setChoosenCard", val);
      }
    },
    guardarTarjeta: {
      get() {
        return this.$store.state.pedido.guardarTarjeta;
      },
      set(val) {
        this.$store.commit("pedido/setGuardarTarjeta", val);
      }
    },
    loadingFinalizar: {
      get() {
        return this.$store.state.pedido.loadingFinalizar;
      },
      set(value) {
        this.$store.commit("pedido/setLoadingFinalizar", value);
      }
    },
    mostrarAdd: function() {
      let r =
        !this.formasFiltradas ||
        this.formasFiltradas.length == 0 ||
        this.mostrarAddButton;
      return r;
    },
    formasFiltradas: function() {
      let _vue = this;
      let res = [];
      return this.formasPago;
    }
  },
  methods: {
    openUrlIframe(url) {
      this.dialogPagoStripe = true;
      this.urlStripe = url;
    },
    eliminar(obj) {
      let id = obj.id;
      console.log(obj);
    },
    onFocus: function() {
      this.resetChoosen();
      if (!this.stripeCardInitialized) {
        this.stripeCardInitialized = true;
        this.$watch(() => {
          if (this.$refs.stripeCard.okToSubmit) {
            this.$refs.stripeCard.processCard();
          }
        });
      }
    },
    onProcessed: function() {},
    resetChoosen() {
      this.settings = null;
    }
  },

  watch: {
    confirmarPagoDialog(v) {
      if (!v) {
        //se cierra modal pago online, se reinician datos
      } else {
        this.newCard = null;
        this.$refs.stripeCard.clearableCallback();
        this.settings = null;
        this.guardarTarjeta = true;
      }
    },
    settings: function(newV) {
      this.choosenCard = this.formasFiltradas[newV];
      this.$refs.stripeCard.val = "";
    }
  },
  mounted() {
    //this.stripe = Stripe("pk_test_oUctEKRV5JBUZKp7HXBODuYP");
  }
};
</script> 
 
<style>
.w-100 {
  width: 100%;
}
.border {
  border: 1px solid #000;
}
.classCard {
  border: 1px solid #000;
  background: #fff;
}
</style>